import i18n from "../../plugins/I18nPlugin";

export function isNotEmptyArrayRule(
  message = "report.formPersonalData.mandatoryInput"
): (value: any[]) => boolean | string {
  return value => !!value.length || String(i18n.tc(message));
}
